/**
 * Free text context styles using MUI theme values.
 */

import { SxProps, Theme } from '@mui/material';

/**
 * Free text context styles using MUI theme palette references.
 * Defined as a static object since no dynamic parameters are needed.
 */
export const freeTextContextStyles: Record<string, SxProps<Theme>> = {
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },

  label: {
    fontWeight: 500,
    fontSize: '14px',
    color: 'text.primary',
    mb: 0.5,
  },

  textField: {
    '& .MuiOutlinedInput-root': {
      width: '100%',
      fontSize: '14px',
      lineHeight: 1.5,
      bgcolor: 'background.paper',
      borderRadius: '8px',
      '& fieldset': {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'divider',
        borderRadius: '8px',
      },
      '&:hover fieldset': {
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'text.disabled',
      },
      '&.Mui-focused fieldset': {
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: 'primary.main',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '2px',
    },
  },

  characterCount: {
    fontSize: '12px',
    color: 'text.secondary',
    textAlign: 'right',
    mt: 0.5,
  },

  characterCountWarning: {
    fontSize: '12px',
    color: 'error.main',
    textAlign: 'right',
    mt: 0.5,
    fontWeight: 500,
  },
};
